import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';
import schoolImage from '../../assets/services/school.jpg';
import { FaShieldAlt, FaClock, FaUserCheck, FaCarAlt } from 'react-icons/fa';

function CoursesScolaires() {
  const features = [
    {
      icon: <FaShieldAlt />,
      title: "Sécurité Maximale",
      description: "Chauffeurs formés et véhicules équipés spécialement pour le transport scolaire"
    },
    {
      icon: <FaClock />,
      title: "Ponctualité",
      description: "Service régulier et ponctuel pour respecter les horaires scolaires"
    },
    {
      icon: <FaUserCheck />,
      title: "Personnel Qualifié",
      description: "Chauffeurs expérimentés et vérifiés pour le transport d'enfants"
    },
    {
      icon: <FaCarAlt />,
      title: "Véhicules Adaptés",
      description: "Flotte moderne avec équipements de sécurité pour enfants"
    }
  ];

  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${schoolImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Courses Scolaires</h1>
          <p>Transport scolaire sécurisé et fiable pour vos enfants</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-container">
          {/* Description */}
          <div className="service-description">
            <h2>Transport Scolaire de Confiance</h2>
            <p>
              Notre service de transport scolaire assure la sécurité et le confort de vos enfants 
              lors de leurs déplacements quotidiens. Nous comprenons l'importance de la ponctualité 
              et de la fiabilité dans le transport scolaire.
            </p>
            <p>
              Nos chauffeurs expérimentés sont spécialement formés pour le transport d'enfants et 
              nos véhicules sont équipés des dernières technologies de sécurité pour garantir des 
              trajets sereins.
            </p>
          </div>

          {/* Features Grid */}
          <div className="service-features">
            {features.map((feature, index) => (
              <div key={index} className="service-feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="service-cta">
            <h2>Réservez Votre Transport Scolaire</h2>
            <p>
              Contactez-nous pour établir un plan de transport personnalisé pour vos enfants.
            </p>
            <div className="cta-buttons">
              <a href="tel:+41797774444" className="cta-button secondary">
                +41 79 777 44 44
              </a>
              <Link to="/quote" className="cta-button primary">
                Demander un Devis
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default CoursesScolaires; 